import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../services/api.client';
import type { Client } from '@lnr-v2/types';

interface UseClientReturn {
  client: Client | null;
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export const useClient = (id: string | undefined): UseClientReturn => {
  const [client, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchClient = useCallback(async () => {
    if (!id) {
      setClient(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.get(`clients/${id}`);
      const clientData = await response.json<Client>();
      setClient(clientData);
    } catch (err) {
      const error =
        err instanceof Error ? err : new Error('Failed to fetch client');
      setError(error);
      console.error('Error fetching client:', error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchClient();
  }, [fetchClient]);

  return {
    client,
    loading,
    error,
    refetch: fetchClient,
  };
};
